<template>
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentcolor">
    <path
      d="M9 4L10.4 5.4L8.8 7H13C14 7 14.8 7.7 15 8.7C15.1 9.6 15.6 10.4 16.3 11C16.8 11.5 17.5 11.8 18.3 11.9C19.3 12.1 20 12.9 20 13.9V14.9V20H18V13.9C16.9 13.7 15.8 13.2 15 12.5C13.9 11.6 13.3 10.4 13 9H8.8L10.4 10.6L9 12L5 8L9 4Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
